import { FullServiceContactsProps } from 'src/api/ServiceContacts/types'

export enum SortStates {
  BY_NEW = 'byNew',
  BY_ALPHABET = 'byAlphabet',
}

export type Comparator = (
  a: FullServiceContactsProps,
  b: FullServiceContactsProps,
) => number

export type ListOfSortsState = {
  type: SortStates
  title: string
}

export type UseInfoContactWindowProps = {
  toggle: () => void
  toggleEditMode: (contactId: string) => void
}
